export default "__VITE_ASSET__zA7sOdXA__"